export const registerEn = {
  registerPage: {
    joinTitle: "Join Sentinel Crop",
    joinSubtitle: "Create your account to monitor crops, golf courses, and green spaces with satellite technology",
    stepOf: "Step {{step}} of 2",
    firstName: "First Name",
    firstNamePlaceholder: "First name",
    lastName: "Last Name",
    lastNamePlaceholder: "Last name",
    email: "Email",
    emailPlaceholder: "Enter your email",
    password: "Password",
    passwordPlaceholder: "Create a password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    userType: "User Type",
    farmer: "Farmer",
    cooperative: "Cooperative",
    insuranceCompany: "Insurance Company",
    urbanManager: "Urban Green Space Manager",
    farmName: "Farm name",
    companyName: "Company name",
    farmNamePlaceholder: "Your farm name",
    companyNamePlaceholder: "Your company name",
    hectares: "Hectares",
    hectaresPlaceholder: "e.g. 50",
    cropType: "Crop type",
    selectCropType: "Select crop type",
    oliveGrove: "Olive Grove",
    vineyard: "Vineyard",
    wheat: "Wheat",
    corn: "Corn",
    sunflower: "Sunflower",
    canola: "Canola",
    almondTrees: "Almond Trees",
    citrus: "Citrus",
    other: "Other",
    organizationType: "Type of Organization",
    selectOrgType: "Select organization type",
    municipal: "Municipal / City Council",
    maintenanceCompany: "Maintenance Company",
    environmentalNGO: "Environmental NGO",
    environmentalConsulting: "Environmental Consulting",
    managedGreenSpaces: "Number of Green Spaces Managed",
    managedGreenSpacesPlaceholder: "e.g. 15 parks",
    managedGreenSpacesHint: "Parks, gardens, street tree zones, etc.",
    country: "Country",
    selectCountry: "Select country",
    phone: "Phone number",
    phonePlaceholder: "+34 600 000 000",
    agreeTerms: "I agree to the",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    back: "Back",
    continue: "Continue",
    createAccount: "Create Account",
    validating: "Validating...",
    creatingAccount: "Creating account...",
    orSignUpWith: "Or sign up with",
    continueWithGoogle: "Continue with Google",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign in",
    errorAllFields: "Please complete all fields",
    errorPasswordMatch: "Passwords do not match",
    errorRequiredFields: "Please complete all required fields",
    errorFarmerFields: "Farmers must specify hectares and crop type",
    errorCoopFields: "Cooperatives must specify hectares and crop type",
    errorUrbanFields: "Urban managers must specify organization type and number of managed areas",
    errorAccountExists: "This email is already registered. Please sign in instead.",
    accountExistsTitle: "Account exists",
    registrationError: "Registration Error",
    registrationSuccess: "Registration Successful",
    registrationSuccessDesc: "Please check your email to confirm your account, then you can sign in.",
    unexpectedError: "An unexpected error occurred",
    googleSignUpError: "Google Sign-Up Error"
  }
};